module.exports = __webpack_public_path__ + "static/media/MHeiHK-Light.8375e9ec.svg";